import { useAuthStore } from '@/store';

export default function appendJwt(url: string): string {
  const token = useAuthStore.getState().accessToken;
  if (!token) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}jwt=${encodeURIComponent(token)}`;
}
